import styled, { css } from 'styled-components';


export const CatchRegistrationCatchWrapper = styled.div<{ $compact?: boolean }>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.8em;
    width: 100%;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 1em;
    ${({ $compact }) => $compact && css`
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
        margin-top: 0;
        & .MuiInputAdornment-positionStart { display: none; }
        @media (max-width: 600px) { grid-template-columns: minmax(0, 1fr); }
    `}
`;
